function _(o,t,n){t.exports=function(o){return!!o&&("symbol"==typeof o||!!o.constructor&&("Symbol"===o.constructor.name&&"Symbol"===o[o.constructor.toStringTag]))}}
//# sourceMappingURL=is-symbol.min.js.map